import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { useSeo } from "@/hooks/useSeo";
import { finalists } from "@/mocks/finalists";
import FinalistsExplorer from "./components/FinalistsExplorer";

export default function FinalistsPage() {
  useSeo({
    title: "爆料大赛入围名单 - 本届全部候选作品一览 | 爆料大赛",
    description:
      "查看爆料大赛本届完整入围名单，按名场面、反转、花絮、神评论等分类筛选，浏览群众打分与作品亮点，为喜欢的候选投上一票。",
    keywords: "爆料大赛入围名单,爆料大赛候选作品,爆料大赛投票入口,爆料大赛评选",
    path: "/finalists",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        name: "爆料大赛入围名单",
        inLanguage: "zh-CN",
        description: "本届爆料大赛全部入围候选作品集合，支持按分类浏览与搜索。",
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "/" },
          { "@type": "ListItem", position: 2, name: "入围名单", item: "/finalists" },
        ],
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "爆料大赛入围作品列表",
        numberOfItems: finalists.length,
        itemListElement: finalists.map((item, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: item.title,
        })),
      },
    ],
  });

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Header />
      <main className="flex-1 pt-[68px]">
        <div className="w-full bg-background-100 border-b border-background-200">
          <div className="mx-auto max-w-6xl px-4 md:px-8 py-10 md:py-14">
            <Breadcrumb items={[{ label: "入围名单" }]} />
            <h1 className="mt-4 font-heading text-3xl md:text-5xl tracking-wide text-foreground-950">
              本届入围名单
            </h1>
            <p className="mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
              以下作品均已通过人工初审并进入对应分类。你可以按分类筛选或直接搜索关键词，找到想支持的作品后即可打分投票。
            </p>
          </div>
        </div>
        <div className="pt-4">
          <FinalistsExplorer />
        </div>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}